<template>
    <div>
        <b-modal id="DocModal" size="xl" class="modal has-overflow e-doc-height-modal" @shown="prepUrl">
          <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
          <template v-slot:modal-header>
          <div class="w-100">
            <h6 class="e-mtavr-17 e-bold modal-title">დოკუმენტის ორიგინალი</h6>
          </div>
          </template>
          <div class="row" style="min-height: 500px">
            <div class="col-12">
              <object type="application/pdf" :data="url+'#toolbar=1'" class="col-12 e-doc-height-modal"></object>
            </div>
          </div>
          <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('DocModal')"
              class="float-right e-mtavr-17 mr-2"
            >დახურვა</b-button>
          </div>
          </template>
        </b-modal>
    </div>
</template>
<script>
export default {
  props: ['documentUrl'],
  data () {
    return {
      url: '',
      loading: false
    }
  },
  methods: {
    prepUrl () {
      this.url = this.documentUrl
    },
    close (id) {
      this.$bvModal.hide(id)
    }
  }
}
</script>
